// extracted by mini-css-extract-plugin
export default {"container":"users-query_container__vpnya","box":"users-query_box__MUSCk","wrapper":"users-query_wrapper__m+nXC","title":"users-query_title__DB8yV"};